import { render, staticRenderFns } from "./answer-collect.vue?vue&type=template&id=6fcb639d&scoped=true&"
import script from "./answer-collect.vue?vue&type=script&lang=js&"
export * from "./answer-collect.vue?vue&type=script&lang=js&"
import style0 from "./answer-collect.vue?vue&type=style&index=0&id=6fcb639d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fcb639d",
  null
  
)

export default component.exports